export default __webpack_public_path__ + "static/media/tutorial-arrow-white.98ee790a.png";